/* Home-page translations — inline (not in /locales/*.json). Matches the
   pattern used by intake_strings.js. Fallback to Spanish. */

const NL = {
  nav_what: "Wat krijg je", nav_how: "Hoe het werkt", nav_about: "Over ons",
  nav_start_btn: "Start gratis rapport",
  hero_badge_text: "100 gratis rapporten",
  hero_t_l1: "Eerlijk advies", hero_t_l2_pre: "voor jouw ", hero_t_highlight: "zonnedak", hero_t_l2_post: ".",
  hero_p: "Een volledig persoonlijk, zeer uitgebreid rapport — gebaseerd op jouw elektriciteitsfactuur, jouw dak, jouw regio. Geen verkooppraatjes, geen installateurs op je deurmat. Alleen onafhankelijke analyse.",
  hero_cta: "Start mijn gratis rapport",
  hero_price_orig: "€149", hero_price_now: "€0", hero_price_tag: "lancering",
  hero_chk_1: "Geen creditcard", hero_chk_2: "100% onafhankelijk", hero_chk_3: "Klaar in 5 minuten",
  pdf_kicker: "Persoonlijk Dossier",
  pdf_title_l1: "Zonneadvies", pdf_title_l2: "voor jouw woning",
  pdf_consumption: "Jaarverbruik", pdf_system: "Voorgesteld systeem",
  pdf_payback: "Terugverdientijd", pdf_profit: "25-jaar winst",
  pdf_badge_t: "Uitgebreid", pdf_badge_s: "PDF · downloadbaar",
  trust_independent: "Onafhankelijk", trust_no_sale: "Geen verkoop", trust_no_oblig: "Vrijblijvend",
  trust_rating: "4.8 / 5 op basis van eerste lezers",
  del_kicker: "Wat krijg je in het rapport?",
  del_h2_l1: "Een persoonlijk dossier, geen", del_h2_l2: "generieke berekening.",
  d1_t: "Persoonlijke daksatelliet-analyse",
  d1_b: "Jij tekent je dakvlak op de satellietfoto, wij berekenen het bruikbare oppervlak en combineren dat met jouw opgegeven oriëntatie en hellingshoek.",
  d1_map_label: "Jouw dak op de kaart",
  d2_t: "Op-maat systeem-ontwerp",
  d2_b: "Aantal panelen, type omvormer en batterijgrootte — afgestemd op JOUW verbruik uit je elektriciteitsfactuur, niet een gemiddelde.",
  spec_panels: "Panelen", spec_inverter: "Omvormer", spec_battery: "Batterij",
  d3_t: "ROI & terugverdientijd",
  d3_b: "Exacte berekening van besparing per maand, terugverdientijd in jaren, en winst over 25 jaar levensduur.",
  d4_t: "Subsidies & belastingvoordelen",
  d4_b: "IRPF-aftrek, IBI-korting, EU-fondsen en Next Generation — alles dat geldt voor JOUW gemeente en provincie.",
  d5_t: "Vergelijking met marktprijzen",
  d5_b: "We tonen wat je nu betaalt vs. wat eerlijk is, op basis van anonieme prijsdata uit honderden Spaanse offertes.",
  d6_t: "Een zeer uitgebreid rapport",
  d6_b: "Compleet, leesbaar, downloadable. Geen marketing-fluff — alleen onafhankelijke analyse, geschikt om aan installateurs te tonen.",
  d7_t: "Gratis tweede mening",
  d7_b: "Heb je offertes? Upload ze. Wij geven onafhankelijke feedback per kwaliteit, prijs en garantie — zonder commerciële belangen.",
  d7_cta: "Start nu",
  free_kicker: "Summer Sale",
  free_h2_l1: "100 gratis rapporten", free_h2_l2: "deze zomer.",
  free_p_html: "Onze <strong>Summer Sale</strong>: de eerste 100 huiseigenaren in Spanje krijgen hun volledige zonneadvies-dossier <strong>gratis</strong>. Daarna gaan we naar onze normale prijs van €149.",
  free_b1_t: "Onze AI kent de Spaanse markt",
  free_b1_b: "Jij krijgt het voordeel. We vergelijken jouw situatie met duizenden andere — geen onderbuik, alleen data.",
  free_b2_t: "Wij bewijzen dat het werkt",
  free_b2_b: "Liever 100 mensen écht helpen dan €149 uitgeven aan ads. Tevreden lezers vertellen het verder — dat is onze groeistrategie.",
  free_b3_t: "Daarna €149 — geen kleine lettertjes",
  free_b3_b: "Zodra de eerste 100 vol zijn gaan we naar onze normale prijs. Geen abonnement, geen verborgen kosten. Je betaalt één keer of helemaal niet.",
  how_kicker: "Hoe het werkt",
  how_h2: "In 3 stappen naar je dossier.",
  st1_t: "Beantwoord 10 vragen", st1_b: "Upload je elektriciteitsfactuur, teken je dak op de kaart, vertel ons over je woning. Duurt 5 minuten.",
  st2_t: "Wij analyseren je dak",  st2_b: "Onze algoritmes berekenen het optimale systeem, je ROI en de subsidies in jouw regio.",
  st3_t: "Rapport in je mailbox",  st3_b: "Binnen 24 uur ontvang je het volledige rapport — klaar om met installateurs te delen.",
  cta_h2: "Klaar om te zien wat zon écht oplevert voor jouw woning?",
  cta_p_html: "<s>€149</s> — vandaag <b>€0</b>. Geen creditcard, geen abonnement, geen verplichtingen.",
  cta_btn: "Start mijn gratis rapport",
  ft_copy: "© 2026 DoctorSol · Onafhankelijk zonneadvies",
  ft_privacy: "Privacy", ft_terms: "Voorwaarden", ft_contact: "Contact",
};

const EN = {
  nav_what: "What you get", nav_how: "How it works", nav_about: "About",
  nav_start_btn: "Start free report",
  hero_badge_text: "100 free reports",
  hero_t_l1: "Honest advice", hero_t_l2_pre: "for your ", hero_t_highlight: "solar roof", hero_t_l2_post: ".",
  hero_p: "A fully personal, deeply detailed report — based on your electricity bill, your roof, your region. No sales talk, no installers at your door. Just independent analysis.",
  hero_cta: "Start my free report",
  hero_price_orig: "€149", hero_price_now: "€0", hero_price_tag: "launch",
  hero_chk_1: "No credit card", hero_chk_2: "100% independent", hero_chk_3: "Ready in 5 minutes",
  pdf_kicker: "Personal Dossier",
  pdf_title_l1: "Solar advice", pdf_title_l2: "for your home",
  pdf_consumption: "Annual usage", pdf_system: "Proposed system",
  pdf_payback: "Payback period", pdf_profit: "25-year profit",
  pdf_badge_t: "Extensive", pdf_badge_s: "PDF · downloadable",
  trust_independent: "Independent", trust_no_sale: "No sales", trust_no_oblig: "No obligation",
  trust_rating: "4.8 / 5 from first readers",
  del_kicker: "What's in the report?",
  del_h2_l1: "A personal dossier, not a", del_h2_l2: "generic calculation.",
  d1_t: "Personal roof satellite analysis",
  d1_b: "You draw your roof on the satellite image; we compute the usable surface and combine it with your orientation and tilt.",
  d1_map_label: "Your roof on the map",
  d2_t: "Tailored system design",
  d2_b: "Number of panels, inverter type and battery size — tuned to YOUR usage from your bill, not an average.",
  spec_panels: "Panels", spec_inverter: "Inverter", spec_battery: "Battery",
  d3_t: "ROI & payback time",
  d3_b: "Exact calculation of monthly savings, payback in years, and 25-year profit over system lifetime.",
  d4_t: "Subsidies & tax breaks",
  d4_b: "IRPF deduction, IBI bonus, EU funds and Next Generation — all that applies in YOUR municipality and province.",
  d5_t: "Market price comparison",
  d5_b: "We show what you'd pay vs. what's fair, based on anonymized data from hundreds of Spanish quotes.",
  d6_t: "A truly extensive report",
  d6_b: "Complete, readable, downloadable. No marketing fluff — only independent analysis, ready to share with installers.",
  d7_t: "Free second opinion",
  d7_b: "Have quotes? Upload them. We give independent feedback on quality, price and guarantee — no commercial agenda.",
  d7_cta: "Start now",
  free_kicker: "Summer Sale",
  free_h2_l1: "100 free reports", free_h2_l2: "this summer.",
  free_p_html: "Our <strong>Summer Sale</strong>: the first 100 homeowners in Spain get their full solar advice dossier <strong>for free</strong>. After that we go back to our regular €149 price.",
  free_b1_t: "Our AI knows the Spanish market",
  free_b1_b: "You get the benefit. We compare your situation against thousands of others — no gut feeling, only data.",
  free_b2_t: "We're proving it works",
  free_b2_b: "We'd rather help 100 people for real than spend €149 on ads. Happy readers spread the word — that's our growth strategy.",
  free_b3_t: "Then €149 — no fine print",
  free_b3_b: "Once the first 100 are claimed we go back to our normal price. No subscription, no hidden cost. You pay once, or not at all.",
  how_kicker: "How it works",
  how_h2: "Your dossier in 3 steps.",
  st1_t: "Answer 10 questions", st1_b: "Upload your electricity bill, draw your roof on the map, tell us about your home. Takes 5 minutes.",
  st2_t: "We analyse your roof",  st2_b: "Our algorithms compute the optimal system, your ROI and the subsidies in your region.",
  st3_t: "Report in your inbox",  st3_b: "Within 24 hours you'll receive the full report — ready to share with installers.",
  cta_h2: "Ready to see what solar truly delivers for your home?",
  cta_p_html: "<s>€149</s> — today <b>€0</b>. No credit card, no subscription, no obligations.",
  cta_btn: "Start my free report",
  ft_copy: "© 2026 DoctorSol · Independent solar advice",
  ft_privacy: "Privacy", ft_terms: "Terms", ft_contact: "Contact",
};

const ES = {
  nav_what: "Qué recibes", nav_how: "Cómo funciona", nav_about: "Sobre nosotros",
  nav_start_btn: "Empezar informe gratis",
  hero_badge_text: "100 informes gratis",
  hero_t_l1: "Asesoría honesta", hero_t_l2_pre: "para tu ", hero_t_highlight: "tejado solar", hero_t_l2_post: ".",
  hero_p: "Un informe completamente personal y muy detallado — basado en tu factura eléctrica, tu tejado, tu región. Sin ventas, sin instaladores en tu puerta. Solo análisis independiente.",
  hero_cta: "Empezar mi informe gratis",
  hero_price_orig: "€149", hero_price_now: "€0", hero_price_tag: "lanzamiento",
  hero_chk_1: "Sin tarjeta", hero_chk_2: "100% independiente", hero_chk_3: "Listo en 5 minutos",
  pdf_kicker: "Dossier Personal",
  pdf_title_l1: "Asesoría solar", pdf_title_l2: "para tu vivienda",
  pdf_consumption: "Consumo anual", pdf_system: "Sistema propuesto",
  pdf_payback: "Periodo de retorno", pdf_profit: "Beneficio 25 años",
  pdf_badge_t: "Extenso", pdf_badge_s: "PDF · descargable",
  trust_independent: "Independiente", trust_no_sale: "Sin ventas", trust_no_oblig: "Sin compromiso",
  trust_rating: "4,8 / 5 de los primeros lectores",
  del_kicker: "¿Qué incluye el informe?",
  del_h2_l1: "Un dossier personal, no un", del_h2_l2: "cálculo genérico.",
  d1_t: "Análisis satelital personal del tejado",
  d1_b: "Tú dibujas tu tejado en la imagen satelital y nosotros calculamos la superficie útil combinándola con tu orientación e inclinación.",
  d1_map_label: "Tu tejado en el mapa",
  d2_t: "Diseño del sistema a medida",
  d2_b: "Número de paneles, tipo de inversor y tamaño de batería — adaptados a TU consumo según tu factura, no a un promedio.",
  spec_panels: "Paneles", spec_inverter: "Inversor", spec_battery: "Batería",
  d3_t: "ROI y retorno de inversión",
  d3_b: "Cálculo exacto del ahorro mensual, el retorno en años y el beneficio a 25 años.",
  d4_t: "Subvenciones y ventajas fiscales",
  d4_b: "Deducción IRPF, bonificación IBI, fondos UE y Next Generation — todo lo que aplica en TU municipio y provincia.",
  d5_t: "Comparación con precios de mercado",
  d5_b: "Mostramos lo que pagarías frente a lo que es justo, basándonos en datos anónimos de cientos de presupuestos en España.",
  d6_t: "Un informe muy extenso",
  d6_b: "Completo, legible y descargable. Sin marketing — solo análisis independiente, listo para enseñar a instaladores.",
  d7_t: "Segunda opinión gratis",
  d7_b: "¿Tienes presupuestos? Súbelos. Damos feedback independiente sobre calidad, precio y garantía — sin intereses comerciales.",
  d7_cta: "Empezar ahora",
  free_kicker: "Summer Sale",
  free_h2_l1: "100 informes gratis", free_h2_l2: "este verano.",
  free_p_html: "Nuestra <strong>Summer Sale</strong>: los primeros 100 propietarios en España reciben su dossier solar completo <strong>gratis</strong>. Después volvemos a nuestro precio normal de €149.",
  free_b1_t: "Nuestra IA conoce el mercado español",
  free_b1_b: "El beneficio es para ti. Comparamos tu situación con miles más — sin intuición, solo datos.",
  free_b2_t: "Demostramos que funciona",
  free_b2_b: "Preferimos ayudar a 100 personas de verdad que gastar €149 en anuncios. Lectores satisfechos lo cuentan — esa es nuestra estrategia.",
  free_b3_t: "Después €149 — sin letra pequeña",
  free_b3_b: "Cuando los primeros 100 estén llenos, volvemos al precio normal. Sin suscripción, sin cargos ocultos. Pagas una vez, o nada.",
  how_kicker: "Cómo funciona",
  how_h2: "Tu dossier en 3 pasos.",
  st1_t: "Responde 10 preguntas", st1_b: "Sube tu factura eléctrica, dibuja tu tejado en el mapa y cuéntanos sobre tu vivienda. 5 minutos.",
  st2_t: "Analizamos tu tejado",  st2_b: "Nuestros algoritmos calculan el sistema óptimo, tu ROI y las subvenciones de tu región.",
  st3_t: "Informe en tu buzón",   st3_b: "En 24 horas recibirás el informe completo — listo para compartir con instaladores.",
  cta_h2: "¿Listo para ver lo que la energía solar realmente aporta a tu hogar?",
  cta_p_html: "<s>€149</s> — hoy <b>€0</b>. Sin tarjeta, sin suscripción, sin compromisos.",
  cta_btn: "Empezar mi informe gratis",
  ft_copy: "© 2026 DoctorSol · Asesoría solar independiente",
  ft_privacy: "Privacidad", ft_terms: "Términos", ft_contact: "Contacto",
};

const DE = {
  nav_what: "Was Sie erhalten", nav_how: "So funktioniert's", nav_about: "Über uns",
  nav_start_btn: "Gratis-Bericht starten",
  hero_badge_text: "100 kostenlose Berichte",
  hero_t_l1: "Ehrlicher Rat", hero_t_l2_pre: "für Ihr ", hero_t_highlight: "Solardach", hero_t_l2_post: ".",
  hero_p: "Ein vollständig persönlicher, ausführlicher Bericht — basierend auf Ihrer Stromrechnung, Ihrem Dach, Ihrer Region. Kein Verkaufsgespräch, keine Installateure vor der Tür. Nur unabhängige Analyse.",
  hero_cta: "Meinen Gratis-Bericht starten",
  hero_price_orig: "€149", hero_price_now: "€0", hero_price_tag: "Launch",
  hero_chk_1: "Keine Kreditkarte", hero_chk_2: "100% unabhängig", hero_chk_3: "Fertig in 5 Min.",
  pdf_kicker: "Persönliches Dossier",
  pdf_title_l1: "Solarberatung", pdf_title_l2: "für Ihr Zuhause",
  pdf_consumption: "Jahresverbrauch", pdf_system: "Vorgeschlagenes System",
  pdf_payback: "Amortisation", pdf_profit: "25-Jahre Gewinn",
  pdf_badge_t: "Ausführlich", pdf_badge_s: "PDF · herunterladbar",
  trust_independent: "Unabhängig", trust_no_sale: "Kein Verkauf", trust_no_oblig: "Unverbindlich",
  trust_rating: "4,8 / 5 von ersten Lesern",
  del_kicker: "Was steht im Bericht?",
  del_h2_l1: "Ein persönliches Dossier, keine", del_h2_l2: "generische Berechnung.",
  d1_t: "Persönliche Dach-Satellitenanalyse",
  d1_b: "Sie zeichnen Ihr Dach auf das Satellitenbild; wir berechnen die nutzbare Fläche und kombinieren sie mit Ihrer Ausrichtung und Neigung.",
  d1_map_label: "Ihr Dach auf der Karte",
  d2_t: "Maßgeschneidertes Systemdesign",
  d2_b: "Anzahl der Module, Wechselrichtertyp und Batteriegröße — abgestimmt auf IHREN Verbrauch laut Rechnung, nicht auf einen Durchschnitt.",
  spec_panels: "Module", spec_inverter: "Wechselrichter", spec_battery: "Batterie",
  d3_t: "ROI & Amortisation",
  d3_b: "Exakte Berechnung der monatlichen Ersparnis, Amortisation in Jahren und Gewinn über 25 Jahre Lebensdauer.",
  d4_t: "Förderungen & Steuervorteile",
  d4_b: "IRPF-Abzug, IBI-Bonus, EU-Mittel und Next Generation — alles, was in IHRER Gemeinde und Provinz gilt.",
  d5_t: "Vergleich mit Marktpreisen",
  d5_b: "Wir zeigen, was Sie zahlen würden vs. was fair ist, basierend auf anonymisierten Daten aus hunderten spanischen Angeboten.",
  d6_t: "Ein wirklich ausführlicher Bericht",
  d6_b: "Vollständig, lesbar, herunterladbar. Kein Marketing-Geschwafel — nur unabhängige Analyse, bereit zum Teilen mit Installateuren.",
  d7_t: "Kostenlose Zweitmeinung",
  d7_b: "Haben Sie Angebote? Laden Sie sie hoch. Unabhängiges Feedback zu Qualität, Preis und Garantie — ohne kommerzielle Interessen.",
  d7_cta: "Jetzt starten",
  free_kicker: "Summer Sale",
  free_h2_l1: "100 kostenlose Berichte", free_h2_l2: "diesen Sommer.",
  free_p_html: "Unsere <strong>Summer Sale</strong>: Die ersten 100 Eigentümer in Spanien erhalten ihr vollständiges Solar-Dossier <strong>kostenlos</strong>. Danach zurück zu unserem regulären Preis von €149.",
  free_b1_t: "Unsere KI kennt den spanischen Markt",
  free_b1_b: "Der Vorteil ist Ihrer. Wir vergleichen Ihre Situation mit Tausenden anderen — kein Bauchgefühl, nur Daten.",
  free_b2_t: "Wir beweisen, dass es funktioniert",
  free_b2_b: "Lieber 100 Menschen wirklich helfen als €149 für Anzeigen ausgeben. Zufriedene Leser empfehlen weiter — das ist unsere Strategie.",
  free_b3_t: "Danach €149 — kein Kleingedrucktes",
  free_b3_b: "Sobald die ersten 100 vergeben sind, zurück zum Normalpreis. Kein Abo, keine versteckten Kosten. Einmalig oder gar nicht.",
  how_kicker: "So funktioniert's",
  how_h2: "Ihr Dossier in 3 Schritten.",
  st1_t: "10 Fragen beantworten", st1_b: "Stromrechnung hochladen, Dach auf der Karte zeichnen, uns über Ihr Zuhause erzählen. Dauert 5 Minuten.",
  st2_t: "Wir analysieren Ihr Dach",  st2_b: "Unsere Algorithmen berechnen das optimale System, Ihren ROI und die Förderungen in Ihrer Region.",
  st3_t: "Bericht im Postfach",  st3_b: "Innerhalb 24h erhalten Sie den vollständigen Bericht — bereit zum Teilen mit Installateuren.",
  cta_h2: "Bereit zu sehen, was Solar wirklich für Ihr Zuhause bedeutet?",
  cta_p_html: "<s>€149</s> — heute <b>€0</b>. Keine Kreditkarte, kein Abo, keine Verpflichtungen.",
  cta_btn: "Meinen Gratis-Bericht starten",
  ft_copy: "© 2026 DoctorSol · Unabhängige Solarberatung",
  ft_privacy: "Datenschutz", ft_terms: "AGB", ft_contact: "Kontakt",
};

const FR = {
  nav_what: "Ce que vous obtenez", nav_how: "Comment ça marche", nav_about: "À propos",
  nav_start_btn: "Démarrer rapport gratuit",
  hero_badge_text: "100 rapports gratuits",
  hero_t_l1: "Conseil honnête", hero_t_l2_pre: "pour votre ", hero_t_highlight: "toit solaire", hero_t_l2_post: ".",
  hero_p: "Un rapport entièrement personnel et détaillé — basé sur votre facture d'électricité, votre toit, votre région. Pas de vente, pas d'installateurs à votre porte. Juste de l'analyse indépendante.",
  hero_cta: "Démarrer mon rapport gratuit",
  hero_price_orig: "149 €", hero_price_now: "0 €", hero_price_tag: "lancement",
  hero_chk_1: "Sans carte", hero_chk_2: "100% indépendant", hero_chk_3: "Prêt en 5 min",
  pdf_kicker: "Dossier Personnel",
  pdf_title_l1: "Conseil solaire", pdf_title_l2: "pour votre logement",
  pdf_consumption: "Consommation annuelle", pdf_system: "Système proposé",
  pdf_payback: "Retour sur invest.", pdf_profit: "Profit 25 ans",
  pdf_badge_t: "Détaillé", pdf_badge_s: "PDF · téléchargeable",
  trust_independent: "Indépendant", trust_no_sale: "Sans vente", trust_no_oblig: "Sans engagement",
  trust_rating: "4,8 / 5 selon les premiers lecteurs",
  del_kicker: "Que contient le rapport ?",
  del_h2_l1: "Un dossier personnel, pas un", del_h2_l2: "calcul générique.",
  d1_t: "Analyse satellite personnelle du toit",
  d1_b: "Vous dessinez votre toit sur l'image satellite ; nous calculons la surface utile en combinant orientation et inclinaison.",
  d1_map_label: "Votre toit sur la carte",
  d2_t: "Conception sur mesure",
  d2_b: "Nombre de panneaux, type d'onduleur, taille de batterie — selon VOTRE consommation réelle, pas une moyenne.",
  spec_panels: "Panneaux", spec_inverter: "Onduleur", spec_battery: "Batterie",
  d3_t: "ROI & retour sur investissement",
  d3_b: "Calcul précis de l'économie mensuelle, retour en années et profit sur 25 ans.",
  d4_t: "Subventions & avantages fiscaux",
  d4_b: "Déduction IRPF, bonus IBI, fonds UE et Next Generation — tout ce qui s'applique à VOTRE commune et province.",
  d5_t: "Comparaison avec les prix du marché",
  d5_b: "Nous montrons ce que vous paieriez vs ce qui est juste, d'après des données anonymes de centaines de devis espagnols.",
  d6_t: "Un rapport vraiment détaillé",
  d6_b: "Complet, lisible, téléchargeable. Pas de marketing — juste de l'analyse indépendante, prête à montrer aux installateurs.",
  d7_t: "Deuxième avis gratuit",
  d7_b: "Vous avez des devis ? Téléchargez-les. Nous donnons un retour indépendant sur qualité, prix et garantie — sans intérêt commercial.",
  d7_cta: "Démarrer maintenant",
  free_kicker: "Summer Sale",
  free_h2_l1: "100 rapports gratuits", free_h2_l2: "cet été.",
  free_p_html: "Notre <strong>Summer Sale</strong> : les 100 premiers propriétaires en Espagne obtiennent leur dossier solaire complet <strong>gratuitement</strong>. Ensuite, retour au tarif normal de 149 €.",
  free_b1_t: "Notre IA connaît le marché espagnol",
  free_b1_b: "L'avantage est pour vous. Nous comparons votre situation à des milliers d'autres — pas d'intuition, que des données.",
  free_b2_t: "Nous prouvons que ça marche",
  free_b2_b: "Plutôt aider 100 personnes pour de vrai que dépenser 149 € en pub. Les lecteurs satisfaits font passer le mot.",
  free_b3_t: "Ensuite 149 € — sans petites lignes",
  free_b3_b: "Quand les 100 premiers sont pris, retour au tarif normal. Pas d'abonnement, pas de coûts cachés. Vous payez une fois, ou pas du tout.",
  how_kicker: "Comment ça marche",
  how_h2: "Votre dossier en 3 étapes.",
  st1_t: "Répondez à 10 questions", st1_b: "Téléchargez votre facture, dessinez votre toit, parlez-nous de votre logement. 5 minutes.",
  st2_t: "Nous analysons votre toit",  st2_b: "Nos algorithmes calculent le système optimal, votre ROI et les subventions de votre région.",
  st3_t: "Rapport dans votre boîte",   st3_b: "Sous 24h, vous recevrez le rapport complet — prêt à partager avec les installateurs.",
  cta_h2: "Prêt à voir ce que le solaire apporte vraiment à votre logement ?",
  cta_p_html: "<s>149 €</s> — aujourd'hui <b>0 €</b>. Sans carte, sans abonnement, sans engagement.",
  cta_btn: "Démarrer mon rapport gratuit",
  ft_copy: "© 2026 DoctorSol · Conseil solaire indépendant",
  ft_privacy: "Confidentialité", ft_terms: "Conditions", ft_contact: "Contact",
};

const DA = {
  nav_what: "Hvad du får", nav_how: "Sådan virker det", nav_about: "Om os",
  nav_start_btn: "Start gratis rapport",
  hero_badge_text: "100 gratis rapporter",
  hero_t_l1: "Ærlig rådgivning", hero_t_l2_pre: "til dit ", hero_t_highlight: "solcelletag", hero_t_l2_post: ".",
  hero_p: "En fuldt personlig, dybt detaljeret rapport — baseret på din elregning, dit tag, din region. Intet salgssnak, ingen installatører ved døren. Kun uafhængig analyse.",
  hero_cta: "Start min gratis rapport",
  hero_price_orig: "149 €", hero_price_now: "0 €", hero_price_tag: "lancering",
  hero_chk_1: "Intet kort", hero_chk_2: "100% uafhængig", hero_chk_3: "Klar på 5 min",
  pdf_kicker: "Personligt Dossier",
  pdf_title_l1: "Solrådgivning", pdf_title_l2: "til din bolig",
  pdf_consumption: "Årligt forbrug", pdf_system: "Foreslået system",
  pdf_payback: "Tilbagebetalingstid", pdf_profit: "25-års profit",
  pdf_badge_t: "Omfattende", pdf_badge_s: "PDF · downloadbar",
  trust_independent: "Uafhængig", trust_no_sale: "Intet salg", trust_no_oblig: "Uforpligtende",
  trust_rating: "4,8 / 5 fra første læsere",
  del_kicker: "Hvad indeholder rapporten?",
  del_h2_l1: "Et personligt dossier, ikke en", del_h2_l2: "generisk beregning.",
  d1_t: "Personlig satellitanalyse af tag",
  d1_b: "Du tegner dit tag på satellitbilledet; vi beregner den brugbare flade og kombinerer med orientering og hældning.",
  d1_map_label: "Dit tag på kortet",
  d2_t: "Skræddersyet systemdesign",
  d2_b: "Antal paneler, invertertype og batteristørrelse — tilpasset DIT forbrug fra regningen, ikke et gennemsnit.",
  spec_panels: "Paneler", spec_inverter: "Inverter", spec_battery: "Batteri",
  d3_t: "ROI & tilbagebetalingstid",
  d3_b: "Præcis beregning af månedlig besparelse, tilbagebetaling i år og 25-års profit.",
  d4_t: "Tilskud & skattefordele",
  d4_b: "IRPF-fradrag, IBI-bonus, EU-midler og Next Generation — alt der gælder i DIN kommune og provins.",
  d5_t: "Sammenligning med markedspriser",
  d5_b: "Vi viser hvad du ville betale vs. hvad der er fair, baseret på anonyme data fra hundredvis af spanske tilbud.",
  d6_t: "En virkelig omfattende rapport",
  d6_b: "Komplet, læsbar, downloadbar. Ingen marketing-fluff — kun uafhængig analyse, klar at dele med installatører.",
  d7_t: "Gratis second opinion",
  d7_b: "Har du tilbud? Upload dem. Vi giver uafhængig feedback på kvalitet, pris og garanti — uden kommercielle interesser.",
  d7_cta: "Start nu",
  free_kicker: "Summer Sale",
  free_h2_l1: "100 gratis rapporter", free_h2_l2: "denne sommer.",
  free_p_html: "Vores <strong>Summer Sale</strong>: De første 100 boligejere i Spanien får deres fulde sol-dossier <strong>gratis</strong>. Derefter tilbage til vores normale pris på 149 €.",
  free_b1_t: "Vores AI kender det spanske marked",
  free_b1_b: "Fordelen er din. Vi sammenligner din situation med tusindvis andre — ingen mavefornemmelse, kun data.",
  free_b2_t: "Vi beviser, det virker",
  free_b2_b: "Hellere hjælpe 100 mennesker rigtigt end bruge 149 € på reklamer. Tilfredse læsere fortæller det videre.",
  free_b3_t: "Derefter 149 € — ingen småskrift",
  free_b3_b: "Når de første 100 er fyldt, tilbage til normal pris. Intet abonnement, ingen skjulte gebyrer.",
  how_kicker: "Sådan virker det",
  how_h2: "Dit dossier i 3 trin.",
  st1_t: "Besvar 10 spørgsmål", st1_b: "Upload din elregning, tegn dit tag på kortet, fortæl om din bolig. 5 minutter.",
  st2_t: "Vi analyserer dit tag",  st2_b: "Vores algoritmer beregner det optimale system, dit ROI og tilskud i din region.",
  st3_t: "Rapport i din indbakke", st3_b: "Inden for 24 timer modtager du den fulde rapport — klar at dele med installatører.",
  cta_h2: "Klar til at se hvad sol virkelig giver din bolig?",
  cta_p_html: "<s>149 €</s> — i dag <b>0 €</b>. Intet kort, intet abonnement, ingen forpligtelser.",
  cta_btn: "Start min gratis rapport",
  ft_copy: "© 2026 DoctorSol · Uafhængig solrådgivning",
  ft_privacy: "Privatliv", ft_terms: "Vilkår", ft_contact: "Kontakt",
};

const RU = {
  nav_what: "Что вы получите", nav_how: "Как это работает", nav_about: "О нас",
  nav_start_btn: "Начать бесплатный отчёт",
  hero_badge_text: "100 бесплатных отчётов",
  hero_t_l1: "Честный совет", hero_t_l2_pre: "для вашей ", hero_t_highlight: "солнечной крыши", hero_t_l2_post: ".",
  hero_p: "Полностью персональный, очень подробный отчёт — на основе вашего счёта, крыши и региона. Без продаж, без установщиков у двери. Только независимый анализ.",
  hero_cta: "Начать мой бесплатный отчёт",
  hero_price_orig: "€149", hero_price_now: "€0", hero_price_tag: "запуск",
  hero_chk_1: "Без карты", hero_chk_2: "100% независимо", hero_chk_3: "Готово за 5 мин",
  pdf_kicker: "Личное досье",
  pdf_title_l1: "Солнечная консультация", pdf_title_l2: "для вашего дома",
  pdf_consumption: "Годовое потребление", pdf_system: "Предложенная система",
  pdf_payback: "Срок окупаемости", pdf_profit: "Прибыль за 25 лет",
  pdf_badge_t: "Подробный", pdf_badge_s: "PDF · скачиваемый",
  trust_independent: "Независимо", trust_no_sale: "Без продаж", trust_no_oblig: "Без обязательств",
  trust_rating: "4,8 / 5 от первых читателей",
  del_kicker: "Что в отчёте?",
  del_h2_l1: "Личное досье, а не", del_h2_l2: "общий расчёт.",
  d1_t: "Личный спутниковый анализ крыши",
  d1_b: "Вы рисуете крышу на спутниковом снимке; мы вычисляем полезную площадь и сочетаем её с ориентацией и наклоном.",
  d1_map_label: "Ваша крыша на карте",
  d2_t: "Индивидуальный дизайн системы",
  d2_b: "Количество панелей, тип инвертора и размер батареи — под ВАШЕ потребление по счёту, а не усреднённое.",
  spec_panels: "Панели", spec_inverter: "Инвертор", spec_battery: "Батарея",
  d3_t: "ROI и срок окупаемости",
  d3_b: "Точный расчёт экономии в месяц, окупаемости в годах и прибыли за 25 лет.",
  d4_t: "Субсидии и налоговые льготы",
  d4_b: "Вычет IRPF, скидка IBI, фонды ЕС и Next Generation — всё, что применимо в ВАШЕМ муниципалитете и провинции.",
  d5_t: "Сравнение с ценами рынка",
  d5_b: "Показываем, что заплатили бы вы, против справедливой цены — на основе анонимных данных сотен испанских предложений.",
  d6_t: "По-настоящему подробный отчёт",
  d6_b: "Полный, читаемый, скачиваемый. Без маркетинговой воды — только независимый анализ, готовый поделиться с установщиками.",
  d7_t: "Второе мнение бесплатно",
  d7_b: "Есть предложения? Загрузите. Дадим независимый отзыв о качестве, цене и гарантии — без коммерческих интересов.",
  d7_cta: "Начать сейчас",
  free_kicker: "Summer Sale",
  free_h2_l1: "100 бесплатных отчётов", free_h2_l2: "этим летом.",
  free_p_html: "Наша <strong>Summer Sale</strong>: первые 100 владельцев в Испании получают полное солнечное досье <strong>бесплатно</strong>. Затем — обычная цена €149.",
  free_b1_t: "Наш ИИ знает испанский рынок",
  free_b1_b: "Выгода — вам. Сравниваем вашу ситуацию с тысячами — никаких догадок, только данные.",
  free_b2_t: "Мы доказываем, что это работает",
  free_b2_b: "Лучше реально помочь 100 людям, чем тратить €149 на рекламу. Довольные читатели рассказывают другим.",
  free_b3_t: "Затем €149 — без мелкого шрифта",
  free_b3_b: "Когда первые 100 закончатся — обычная цена. Без подписки, без скрытых платежей. Один раз или совсем нет.",
  how_kicker: "Как это работает",
  how_h2: "Ваше досье за 3 шага.",
  st1_t: "Ответьте на 10 вопросов", st1_b: "Загрузите счёт, нарисуйте крышу на карте, расскажите о доме. 5 минут.",
  st2_t: "Мы анализируем крышу",   st2_b: "Алгоритмы рассчитают оптимальную систему, ROI и субсидии в вашем регионе.",
  st3_t: "Отчёт на почту",        st3_b: "В течение 24ч получите полный отчёт — готовый поделиться с установщиками.",
  cta_h2: "Готовы увидеть, что солнце действительно даёт вашему дому?",
  cta_p_html: "<s>€149</s> — сегодня <b>€0</b>. Без карты, без подписки, без обязательств.",
  cta_btn: "Начать мой бесплатный отчёт",
  ft_copy: "© 2026 DoctorSol · Независимая солнечная консультация",
  ft_privacy: "Конфиденциальность", ft_terms: "Условия", ft_contact: "Контакт",
};

export const HOME_I18N = { nl: NL, en: EN, es: ES, de: DE, fr: FR, da: DA, ru: RU };

export const getHomeT = (lang) => {
  const code = (lang || "es").split("-")[0].toLowerCase();
  return HOME_I18N[code] || HOME_I18N.es;
};
